export const SITE = {
  name: "JCD Customs & Marine",
  tagline: "Automotive & Marine Service Centre",
  location: "205 Aickin Road, Whangamata 3620, New Zealand",
  phone: "07 865 9073",
  email: "office@jcdcustoms.co.nz",
  facebook: "https://www.facebook.com/profile.php?id=100057576694519",
  hours: [
    { days: "Monday - Friday", time: "7:30am - 5:00pm" },
    { days: "Saturday", time: "8:00am - 12:00pm" },
    { days: "Sunday", time: "Closed" },
  ],
};

export const IMAGES = {
  hero: "/img/hero.jpg",
  hotRod: "/img/hotrod.jpg",
  mechanic: "/img/mechanic.jpg",
  marine: "/img/marine.jpg",
  engineering: "/img/engineering.jpg",
  gallery1: "/img/gallery1.jpg",
  gallery2: "/img/gallery2.jpg",
  gallery3: "/img/gallery3.jpg",
};

export const SERVICES = [
  {
    slug: "servicing-repairs",
    title: "Servicing & Repairs",
    blurb: "General car servicing, diagnostics and mechanical repairs for daily drivers, classics and everything between.",
    image: IMAGES.mechanic,
  },
  {
    slug: "wof",
    title: "WOF Inspections",
    blurb: "Warrant of Fitness inspections and repair work to get you back on the road safe and legal, fast.",
    image: IMAGES.gallery3,
  },
  {
    slug: "tyre-alignment",
    title: "Wheel Alignment & Tyres",
    blurb: "Precision wheel alignment and tyre fitting for even wear, sharp handling and a straight steering wheel. Proud stockists of Toyo, Pirelli and more brands available on request.",
    image: IMAGES.hero,
  },
  {
    slug: "marine",
    title: "Marine Services",
    blurb: "Boat and trailer servicing, repairs and engineering to keep you on the water all season long.",
    image: IMAGES.marine,
  },
  {
    slug: "hot-rods",
    title: "Hot Rod Builds",
    blurb: "Ground-up custom builds, chassis work, engine swaps and turn-key hot rods with serious street presence.",
    image: IMAGES.hotRod,
  },
  {
    slug: "light-engineering",
    title: "Light Engineering",
    blurb: "Welding, fabrication and custom one-off parts. If it doesn't exist, we'll build it in-house.",
    image: IMAGES.engineering,
  },
  {
    slug: "auto-electrical",
    title: "Auto Electrical",
    blurb: "Wiring, batteries, alternators, lights and fault-finding — auto electrical diagnostics and repairs done right.",
    image: "/img/auto-electrical.jpg",
  },
  {
    slug: "towing",
    title: "Towing & Breakdown",
    blurb: "Broken down or won't start? We'll come and get you — towing and breakdown recovery to bring your vehicle safely back to the workshop.",
    image: "/img/towing.jpg",
  },
  {
    slug: "mobile-servicing",
    title: "Mobile Servicing & Repairs",
    blurb: "Can't get to us? We'll come to you. On-site servicing and repairs for both automotive and marine — at home, the wharf or the roadside.",
    image: "/img/mobile-service.jpg",
  },
  {
    slug: "retail-shop",
    title: "Retail Shop",
    blurb: "Parts, tyres, marine supplies and workshop consumables over the counter at our Whangamata store. Your local Eziswap Gas agent for LPG and industrial gases.",
    image: IMAGES.gallery1,
  },
];

export const GALLERY = [
  { src: "/img/workshop-action.jpg", caption: "Inside the workshop — classics up on the hoists" },
  { src: "/img/gallery-real-1.jpg", caption: "Up on the hoist in the JCD workshop" },
  { src: "/img/gallery-real-2.jpg", caption: "Hot rod in on the floor" },
  { src: "/img/gallery-real-3.jpg", caption: "Classics filling the workshop" },
  { src: "/img/gallery-real-4.jpg", caption: "Another muscle car heading out" },
  { src: "/img/chukky.jpg", caption: "CHUKKY — rat rod out and about" },
];

export const SHOP_CATEGORIES = [
  { title: "Tyres", blurb: "Road, performance and trailer tyres fitted and aligned on-site.", image: IMAGES.hero },
  { title: "Parts & Accessories", blurb: "Service parts, filters, brakes and performance gear over the counter.", image: IMAGES.gallery2 },
  { title: "Marine Supplies", blurb: "Oils, trailer parts and essentials for the boat this summer.", image: IMAGES.marine },
  { title: "Workshop Consumables", blurb: "Fluids, hardware and engineering supplies for the home garage.", image: IMAGES.gallery3 },
];


export const TEAM = [
  { name: "Matthew Chaplin", role: "Owner / Director / WOF Inspector", initials: "MC", bio: "Leads the shop and every ground-up hot rod build — decades of custom fabrication and engine know-how." },
  { name: "Dominic Chaplin", role: "Manager / Mechanic / WOF Inspector", initials: "DC", bio: "Keeps the workshop running day to day — bookings, jobs and hands-on mechanical work to make sure every vehicle leaves sorted." },
  { name: "Jamie Watt", role: "Head Mechanic / WOF Inspector", initials: "JW", bio: "Runs the mechanical side — servicing, diagnostics, WOF work and repairs across everything from daily drivers to classics." },
  { name: "Miranda Laurenson", role: "Office / Parts Extraordinaire", initials: "ML", bio: "Front of house and parts guru — sorts your orders, enquiries and everything over the counter." },
  { name: "Jude Pratt", role: "Office Manager", initials: "JP", bio: "Keeps the office ticking over — accounts, admin and looking after customers from first call to pickup." },
  { name: "Rusty Wylie", role: "Marine / Small Engines", initials: "RW", bio: "Boats, outboards, trailers and small engines — serviced and repaired to keep you moving on land and water." },
  { name: "Stormy", role: "Workshop Clown", initials: "ST", paw: true, photo: "/img/stormy.webp", bio: "The four-legged boss. Chief greeter, morale officer and full-time good girl on the workshop floor." },
  { name: "Max", role: "Workshop Snorer", initials: "MX", paw: true, photo: "/img/max.jpg", bio: "Second in command of the dog department. Expert napper, part-time greeter and champion snorer." },
  { name: "Charlie", role: "Workshop Princess", initials: "CH", paw: true, photo: "/img/charlie.webp", bio: "Rules the workshop with charm and a wagging tail. Chief cuddle-provider and self-appointed royalty." },
];
